import { render } from "./index.vue?vue&type=template&id=88613bbe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=88613bbe&lang=css"

import exportComponent from "/home/workspace/cf-dkf-web-micro-base-interior-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__